import { GET, POST, PUT } from '../request'

export const getCentrosEstudio = () => GET('/api/core/datos/centro-estudios')

export const getCentrosEstudioProvincia = ({ provincia }) =>
  GET('/api/core/datos/centro-estudios/list/provincia', { provincia })

export const createCentroEstudios = centro =>
  POST('/api/core/datos/centro-estudios', centro)

export const updateCentroEstudios = ({ id, nombre, provincia }) =>
  PUT('/api/core/datos/centro-estudios', { id, nombre, provincia })
